export default {
  nullValue: 'Žiadne dáta',
};
